import { ampli } from 'lib-shared-tracking';

import { PartnerTrackingEventsProps } from '../partners.types';

export const brazePartnerTrackingEvents = ({
  partnerEvents,
}: PartnerTrackingEventsProps): void => {
  partnerEvents.on('braze:profile:received', (payload) =>
    ampli.partnerIntegrationsBrazeProfileReceived(payload),
  );

  partnerEvents.on('braze:email:subscription:opt-in:succeeded', (payload) =>
    ampli.partnerIntegrationsBrazeSubscriptionEmailOptInSucceeded(payload),
  );

  partnerEvents.on(
    'braze:email:subscription:unsubscribe:succeeded',
    (payload) =>
      ampli.partnerIntegrationsBrazeSubscriptionEmailUnsubscribedSucceeded(
        payload,
      ),
  );
};
